import isBrowser from '../isBrowser';
import EventTarget from './EventTarget';
import normalizeHandlers from './normalizeHandlers';
import normalizeTarget from './normalizeTarget';

export default class EventStack {
  targets = new Map();

  sub(eventName, eventHandlers, options = {}) {
    if (!isBrowser()) return;
    const { target = document, pool = 'default' } = options;
    const eventTarget = this.getTarget(target);
    eventTarget.addHandlers(pool, eventName, normalizeHandlers(eventHandlers));
  }

  unsub(eventName, eventHandlers, options = {}) {
    if (!isBrowser()) return;

    const { target = document, pool = 'default' } = options;
    const eventTarget = this.getTarget(target, false);

    if (eventTarget) {
      eventTarget.removeHandlers(
        pool,
        eventName,
        normalizeHandlers(eventHandlers)
      );
      if (!eventTarget.hasHandlers()) this.removeTarget(target);
    }
  }

  getTarget = (target, autoCreate = true) => {
    const normalized = normalizeTarget(target);

    if (this.targets.has(normalized)) return this.targets.get(normalized);
    if (!autoCreate) return null;

    const eventTarget = new EventTarget(normalized);
    this.targets.set(normalized, eventTarget);

    return eventTarget;
  };

  removeTarget = target => {
    this.targets.delete(normalizeTarget(target));
  };
}
